import api from "@/services/api";

const _http = {
    getInfrasDetail(params) {
        return api.get("/infrastructure-detail", { params });
    },
    getInfrasDetailById(id) {
        return api.get(`/infrastructure-detail/${id}`);
    },
    createInfrasDetail(data) {
        return api.post("/infrastructure-detail", data);
    },
    updateInfrasDetail(id, data) {
        return api.put(`/infrastructure-detail/${id}`, data);
    },
};




export default {

    async getAll(params) {
        try {
            const res = await _http.getInfrasDetail(params);
            return {
                data: (res.data.data || []).map((item) => item),
                total: res.data.total || 0,
            };
        } catch (error) {
            console.error(error);
            return { data: [], total: 0 };
        }
    },

    async getById(id) {
        try {
            const res = await _http.getInfrasDetailById(id);
            return res.data.data || {};
        } catch (error) {
            console.error(error);
            return null;
        }
    },


    async create(data) {
        const res = await _http.createInfrasDetail(data);
        return res.data;
    },

    async update(id, data) {
        const res = await _http.updateInfrasDetail(id, data);
        return res.data;
    },
};
